import React, { useEffect, useState } from "react";

function AdminRollerForm({
  roller,
  trainers,
  levels,
  canAssign,
  onCancel,
  onSave,
}) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    birthdate: "",
    levelId: "",
    playlist: "",
    trainerId: "",
  });

  useEffect(() => {
    if (roller) {
      setForm({
        name: roller.name || "",
        phone: roller.phone || "",
        birthdate: roller.birthdate || "",
        levelId: roller.levelId || "",
        playlist: roller.playlist || "",
        trainerId: roller.trainerId || "",
      });
    }
  }, [roller]);

  const updateField = (field) => (event) => {
    setForm({
      ...form,
      [field]: event.target.value,
    });
  };

  const submit = async (event) => {
    event.preventDefault();

    try {
      await onSave({
        ...form,
        levelId: form.levelId || null,
        trainerId: form.trainerId || null,
      });
    } catch (e) {
      return;
    }
  };

  if (!roller) {
    return null;
  }

  return (
    <form className="admin-panel__form" onSubmit={submit}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="h5 mb-0">Редагування роллера</h2>
        <button type="button" className="btn btn-link" onClick={onCancel}>
          Назад
        </button>
      </div>

      <div className="form-group">
        <label>Ім'я</label>
        <input
          className="form-control"
          value={form.name}
          onChange={updateField("name")}
        />
      </div>

      <div className="form-group">
        <label>Телефон</label>
        <input
          className="form-control"
          value={form.phone}
          onChange={updateField("phone")}
        />
      </div>

      <div className="form-group">
        <label>Дата народження</label>
        <input
          className="form-control"
          value={form.birthdate}
          onChange={updateField("birthdate")}
        />
      </div>

      <div className="form-group">
        <label>Рівень</label>
        <select
          className="form-control"
          value={form.levelId}
          onChange={updateField("levelId")}
        >
          <option value="">Без рівня</option>
          {levels.map((level) => (
            <option value={level.id} key={level.id}>
              {level.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Playlist</label>
        <input
          className="form-control"
          value={form.playlist}
          onChange={updateField("playlist")}
        />
      </div>

      {canAssign ? (
        <div className="form-group">
          <label>Тренер</label>
          <select
            className="form-control"
            value={form.trainerId}
            onChange={updateField("trainerId")}
          >
            <option value="">Без тренера</option>
            {trainers.map((trainer) => (
              <option value={trainer.id} key={trainer.id}>
                {trainer.name}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      <div className="admin-panel__actions">
        <button type="submit" className="btn btn-primary">
          Зберегти
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Скасувати
        </button>
      </div>
    </form>
  );
}

export default AdminRollerForm;
